export default __webpack_public_path__ + "static/media/BinIconLight.0fd03a4d.svg";